import { useEffect, useState } from "react";
import { CustomButton } from "../../../set/components";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

const Skeleton = dynamic(() => import("react-loading-skeleton"), {
    ssr: false,
});

export const LearningMaterial = ({
    img,
    handleNext,
    togglePauseTimer,
    cta,
}) => {
    const { isReady, query } = useRouter();

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const shouldPauseTimer = query.pauseTimer == "true";
        if (!loading) togglePauseTimer(shouldPauseTimer ? true : false);
        else togglePauseTimer(true);

        return () => togglePauseTimer(shouldPauseTimer ? true : false);
    }, [loading, isReady]);

    const imgURL = new URL(img);
    imgURL.searchParams.set("tr", "w-450");

    return (
        <div className="px-4 pt-16 text-center">
            <div className="mt-4 text-2xl font-extrabold text-dark-purple">
                Read, learn {"&"} quiz it!
            </div>
            <div className="w-auto h-auto mt-4 shadow-lg mb-9">
                {loading && !img.includes(".mp4") && (
                    <div style={{ display: loading ? "block" : "none" }}>
                        <Skeleton height={"80vh"} />
                    </div>
                )}
                {img.includes(".mp4") ? (
                    <video
                        src={imgURL.href}
                        loop
                        muted
                        playsInline
                        autoPlay
                        style={{
                            width: "100%",
                        }}
                        onPlay={() => {
                            setLoading(false);
                        }}
                    />
                ) : (
                    <div style={{ display: loading ? "none" : "block" }}>
                        <img
                            src={img}
                            alt="learning"
                            className="object-contain w-full h-full"
                            onLoad={() => setLoading(false)}
                        />
                    </div>
                )}
            </div>
            <div className="my-4">
                <CustomButton cta={cta} type="action" onClick={handleNext} />
            </div>
        </div>
    );
};
